// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Liff from "../liff/Liff.bs.js";
import * as React from "react";
import * as Layout from "../Layout.bs.js";

function ProfileEditSuccessPage(Props) {
  return React.createElement(Layout.LogoWithButton.make, {
              children: React.createElement("div", {
                    className: "flex flex-col items-center"
                  }, React.createElement("div", {
                        className: "text-xl font-heading text-center px-3 pt-2 whitespace-pre-line"
                      }, "ขอบคุณสำหรับการอัพเดทข้อมูล\n            เราได้บันทึกข้อมูลของคุณ\n            เรียบร้อยแล้ว")),
              button_label: "ปิด",
              button_onClick: (function (param) {
                  return Liff.closeWindow(undefined);
                })
            });
}

var make = ProfileEditSuccessPage;

export {
  make ,
  
}
/* Liff Not a pure module */
